<template>
    <div class="tag">
        <span v-show="show" class="circle" />

        <slot />
    </div>
</template>

<script>
export default {
    name: "tag",

    props: {
        show: { default: true }
    }
}
</script>

<style>
.tag {
    position: relative;
}

.tag .circle {
    background: #ff6050;
    border: 1px solid #de4232;
    border-radius: 100%;
    height: 10px;
    width: 10px;
    position: absolute;
    top: -5px;
    right: -4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tag.vue